import get from 'lodash/get'

export const singleFile = (value: any): string => {
  try {
    return get(JSON.parse(value), [0, 'virtualPath'])
  } catch {
    return ''
  }
}
